import { connect } from "react-redux"

import {
    keyIssueListInvalidationRequest,
    keyIssueSetFilter,
    keyIssueListSearchRequest,
    keyIssueAddNew
} from "../../../actions/key-issue-actions"

import KeyIssueListWidget from "./KeyIssueListWidget"

const mapStateToProps = ({
    presentation: { keyIssues },
    paging,
    authentication
}) => ({
    isFetching: keyIssues.isFetchingList || keyIssues.isFetchingItem,
    pagingRequest: paging.dimensions[keyIssues.searchCriteria] || {},
    nameSearchTerm: keyIssues.workingFilterModel.name,
    isEmptySearchValue: keyIssues.workingFilterModel.empty,
    canAdd: authentication.permissions.indexOf("w_dimension") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(keyIssueListInvalidationRequest(pagingRequest)),
    onFilterSelect: pagingRequest => () =>
        dispatch(keyIssueSetFilter(true, pagingRequest.searchCriteria)),
    onSearch: ({ target: { name, value, checked } }) =>
        dispatch(
            keyIssueListSearchRequest(name, name === "empty" ? checked : value)
        ),
    onAdd: () => dispatch(keyIssueAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(KeyIssueListWidget)
